export const JWT_TOKEN: string = 'astrea-token';
